/**
 * PageViewTracker — fires GA4 page_view on SPA route changes.
 * Mount inside React Router so useLocation works. Works with gtag.js loaded in index.html.
 * @see https://developers.google.com/analytics/devguides/collection/ga4/single-page-applications
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production' || typeof window.gtag !== 'function') {
      return;
    }
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location]);

  return null;
}
